import { render } from "./uploadFilePanel.vue?vue&type=template&id=af61d054"
import script from "./uploadFilePanel.vue?vue&type=script&lang=js"
export * from "./uploadFilePanel.vue?vue&type=script&lang=js"

import exportComponent from "/www/wwwroot/www.usevia.cn/fileManage/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__